/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_therapie': {
    width: 24,
    height: 32,
    viewBox: '0 0 24 32',
    data: '<path pid="0" d="M6.25 24C2.812 24.603.5 25.729.5 27.019c0 1.925 5.148 3.485 11.5 3.485 6.351 0 11.5-1.56 11.5-3.485 0-1.29-2.313-2.416-5.75-3.019m-3.25 2.5v-8h3v-7a2 2 0 0 0-2-2h-7a2 2 0 0 0-2 2v7h3v8h5zm1-22.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_therapie.js